import { render } from "./FormItems.vue?vue&type=template&id=0e7c7723&ts=true"
import script from "./FormItems.vue?vue&type=script&lang=ts"
export * from "./FormItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__